import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import analyticsApp from './reducers/analyticsApp';
import { loadSessionState as loadSessionStateDefault, saveSessionState } from './sessionStorage';
import {
  loadLocalStorageState as loadStorageStateDefault,
  saveLocalStorageState,
} from './localStorage';

const getInitialState = async () => {
  const sessionState = loadSessionStateDefault() || {};
  const storageState = loadStorageStateDefault() || {};

  // Аутентификация больше не хранится на клиенте (cookie HttpOnly OIDC) — login-slice
  // всегда стартует с дефолта и переопроверяется probe'ом /me/tenants при загрузке.
  // Персистим только backendUrl: его читает обработчик 401 (api/common), не имеющий доступа к store.
  return {
    location: sessionState.location,
    previousLocation: sessionState.previousLocation,
    config: {
      backendUrl: storageState.backendUrl || '',
    },
  };
};

const configureStore = async () => {
  const middlewares = [thunk];

  if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger({ collapsed: true });
    middlewares.push(logger);
  }

  const initialState = await getInitialState();

  const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 10,
  });

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  const store = createStore(analyticsApp, initialState, enhancer);

  store.subscribe(() => {
    saveLocalStorageState({
      backendUrl: store.getState().config.backendUrl || '',
    });

    saveSessionState({
      location: store.getState().location || '',
      previousLocation: store.getState().previousLocation || '',
    });
  });

  return store;
};

export default configureStore;
